import { Accordion, AccordionDetails, AccordionSummary, Divider, Grid } from '@mui/material';
import React, { useEffect, useState } from 'react'
import GlobalButton from '../../../../components/utility/globalButton/button';
import CopyToClipboard from 'react-copy-to-clipboard';
import IconsColor from '../../../../components/utility/iconsColor';
import styles from "../../../../assets/styles/componentStyles/chatbotStyles/chats.module.scss";
import globalStyles from "../../../../assets/styles/global.module.scss";
import popupStyles from '../../../../assets/styles/componentStyles/callAnalysisStyles/callAnalysisAudio.module.scss'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import GlobalTooltip from '../../../../components/utility/tooltip/globalTooltip';

interface OpenAiStepsDataProps {
    selectedTab: string | null,
    setSelectedTab: React.Dispatch<React.SetStateAction<string | null>>,
    dataToShow: any[] | null, //as data response may very here we used any
    openAIStepsData: { flagpopup: boolean, data: any[] },
    sortOpenAIStepsData: (data: any[]) => any[],
    setDataToShow: React.Dispatch<React.SetStateAction<any[] | null>>
}

const OpenAiStepsData: React.FC<OpenAiStepsDataProps> = (props) => {
    
    const { selectedTab, setSelectedTab, dataToShow, openAIStepsData, sortOpenAIStepsData, setDataToShow } = props;

    const hasStepData = openAIStepsData?.data?.length > 0 && openAIStepsData?.data?.[0]?.current_run_steps?.length > 0;
    const hasRunData = openAIStepsData?.data?.length > 0 && openAIStepsData?.data?.[0]?.current_run?.length > 0;
    const hasRunListData = openAIStepsData?.data?.length > 0 && openAIStepsData?.data?.[0]?.run_list?.length > 0;

    const renderTabButton = (buttonText: string, tabKey: string, sx: object) => (
        <Grid item>
            <GlobalButton 
                buttonText={buttonText} 
                onClick={() => setSelectedTab(tabKey)} 
                className={selectedTab == tabKey ? 'primaryButtonStyle' : 'borderedButtonStyle'}
                sx={sx}
            />
        </Grid>
    );

    const [copyText, setCopyText] = useState<string>("Copy") 

    useEffect(() => {
        if (selectedTab) {
            if (openAIStepsData?.data?.length > 0) {
                if (selectedTab == "step" && openAIStepsData.data[0]?.current_run_steps?.length > 0) {
                    setDataToShow(sortOpenAIStepsData(openAIStepsData.data[0].current_run_steps))
                }
                else if (selectedTab == "run" && openAIStepsData.data[0]?.current_run?.length > 0) {
                    setDataToShow(sortOpenAIStepsData(openAIStepsData.data[0].current_run))
                }
                else if (selectedTab == "runlist" && openAIStepsData.data[0]?.run_list?.length > 0) {
                    setDataToShow(sortOpenAIStepsData(openAIStepsData.data[0].run_list))
                }
                else {
                    setDataToShow(null)
                }
            }
        }
    }, [selectedTab])
    
    return (
        <>
            <Grid item className={styles.stepsDataPopupContainer}>
                <Grid container direction={"column"} gap={2}>
                    <Grid item className={globalStyles.fullwidth} textAlign={"center"}>
                        <span className={popupStyles.popupTitleStyle}>Steps Data</span>
                    </Grid>
                    <Grid item className={globalStyles.fullwidth}>
                        <Divider className={styles.dividerGlobalStyle} />
                    </Grid>
                    <Grid item className={globalStyles.fullwidth}>
                        <Grid container alignItems={"center"} justifyContent={"space-between"}>
                            <Grid item>
                                <Grid container gap={2}>
                                    {hasStepData && renderTabButton("Step", "step", { minWidth: "80px" })}
                                    {hasRunData && renderTabButton("Run", "run", { minWidth: "80px" })}
                                    {(!hasStepData && !hasRunData && hasRunListData) && renderTabButton("Run List", "runlist", { minWidth: "100px", cursor: "auto" })}
                                </Grid>
                            </Grid>
                            {(hasStepData || hasRunData) && hasRunListData && renderTabButton("Run List", "runlist", { minWidth: "100px" })}
                        </Grid>

                    </Grid>
                    {dataToShow &&
                        <Grid item className={styles.accordionDrawerStyle}>
                            <Grid container gap={2}>
                                {dataToShow.map((rdata: any, index: number) => (
                                    <Accordion key={index} className={`${styles.agentAccordion} ${styles.transitionAccordion} ${styles.accordionDesignStyle}`}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1-content"
                                            id="panel1-header"
                                            className={styles.dataToShowAccordionSummary}
                                        >
                                            <Grid container gap={"6px"} justifyContent={"space-between"}>
                                                <Grid item>
                                                    <Grid container gap={"6px"}>
                                                        <Grid item className={styles.stepTextStyle}>
                                                            {`Step: ${index + 1} - `}
                                                        </Grid>
                                                        <Grid item className={styles.stepTextValueStyle}>
                                                            {rdata?.step_details?.type || "-"}
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid item className={styles.stepTextStyle} paddingRight={"10px"}>
                                                    <Grid container gap={1} alignItems={"center"}>
                                                        <Grid item className={globalStyles.displayFlexStyle}>
                                                            <CopyToClipboard text={JSON.stringify(rdata, null, 4)}>
                                                                <GlobalTooltip
                                                                    title={copyText}
                                                                    arrow
                                                                    onMouseLeave={() => setCopyText("Copy!")}
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        e.stopPropagation();
                                                                        setCopyText("Copied!");
                                                                    }}
                                                                >
                                                                    <Grid item className={globalStyles.displayFlexStyle}>
                                                                        <IconsColor iconName={"Copy"}
                                                                            fillColor={"black"}
                                                                            width={"15"} height={"15"} />
                                                                    </Grid>
                                                                </GlobalTooltip>
                                                            </CopyToClipboard>
                                                        </Grid>
                                                        <Grid item>
                                                            {`Time: ${rdata.completed_at - rdata.created_at}s`}
                                                        </Grid>
                                                    </Grid>
                                                </Grid>

                                            </Grid>
                                        </AccordionSummary>
                                        <AccordionDetails
                                            className={styles.accordionDetailsStyle}
                                        >
                                            <Grid item xs={12} className={styles.jsonDataStyle}>
                                                <pre key={index} className={styles.jsonDataPreStyle}>
                                                    {JSON.stringify(rdata, null, 4)}
                                                </pre>
                                            </Grid>
                                        </AccordionDetails>
                                    </Accordion>
                                ))}
                            </Grid>
                        </Grid>
                    }
                </Grid>
            </Grid>
        </>
    )
}

export default OpenAiStepsData
